// src/Component/TransactionTable/EditTransactionModal.js
import React, { useEffect } from "react";
import "./transactiontable.css";

export default function EditTransactionModal({
  editingTransaction,
  setEditingTransaction,
  formData,
  setFormData,
  handleUpdate,
}) {
  const CATEGORY_1_OPTIONS = [
    "Makanan & Kebutuhan Rumah Tangga",
    "Transportasi",
    "Konektivitas",
    "Hiburan",
    "Tagihan dan Lainnya",
  ];

  const CATEGORY_2_OPTIONS = ["Primer", "Sekunder", "Tersier"];

  useEffect(() => {
    if (editingTransaction) {
      setFormData({
        description: editingTransaction.description || "",
        nominal: editingTransaction.nominal || "",
        category_1: editingTransaction.category_1 || "",
        category_2: editingTransaction.category_2 || "",
      });
    }
  }, [editingTransaction, setFormData]);

  if (!editingTransaction) return null;

  return (
    <div className="edit-modal">
      <div className="edit-modal-content">
        <h3>Edit Transaksi</h3>

        {/* DESKRIPSI */}
        <label>Deskripsi</label>
        <input
          type="text"
          placeholder="Masukkan deskripsi..."
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
        />
        <label>Nominal</label>
        <input
          type="number"
          placeholder="Masukkan nominal..."
          value={formData.nominal}
          onChange={(e) =>
            setFormData({ ...formData, nominal: e.target.value })
          }
        />
        <label>Kategori Pengeluaran</label>
        <select
          value={formData.category_1}
          onChange={(e) =>
            setFormData({ ...formData, category_1: e.target.value })
          }
        >
          <option value="">Pilih kategori...</option>
          {CATEGORY_1_OPTIONS.map((cat, index) => (
            <option key={index} value={cat}>
              {cat}
            </option>
          ))}
        </select>
        <label>Jenis Kebutuhan</label>
        <select
          value={formData.category_2}
          onChange={(e) =>
            setFormData({ ...formData, category_2: e.target.value })
          }
        >
          <option value="">Pilih jenis kebutuhan...</option>
          {CATEGORY_2_OPTIONS.map((cat, index) => (
            <option key={index} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        <div className="edit-modal-actions">
          <button onClick={handleUpdate}>Simpan</button>
          <button onClick={() => setEditingTransaction(null)}>Batal</button>
        </div>
      </div>
    </div>
  );
}